import { Component, OnInit, Input } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';
import { ConfigTurnsService } from 'src/app/services/turns-services/config-turns-service/config-turns.service';

@Component({
  selector: 'app-turns-config-ticket-photo-editor-card',
  templateUrl: './turns-config-ticket-photo-editor-card.component.html',
  styleUrls: ['./turns-config-ticket-photo-editor-card.component.scss']
})
export class TurnsConfigTicketPhotoEditorCardComponent implements OnInit {

  @Input() image;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private configTurnsService: ConfigTurnsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateTurnTicketImage(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.configTurnsService.updateTurnsConfigImageTicket(imageUrl).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.configTurnsService.refreshTurnsConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('turn-config-image-spinner');
    this.configTurnsService.updateTurnsConfigImageTicket(null).subscribe(
      (res) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.configTurnsService.refreshTurnsConfig();
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.showSpinner = false;
        this.spinnerService.hide('turn-config-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateTurnTicketImage(result[0].Url);
        }
      }
    );
  }
}
